import Vue from 'vue'
import App from './App.vue'
import VTooltip from 'v-tooltip'
import VModal from 'vue-js-modal'
import { Input, RadioGroup, Radio, RadioButton, Button, Row, Col } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlusSquare, faCopy, faExternalLinkAlt, faHandPointRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { getOrCreateGame, store } from './services'

library.add(faPlusSquare, faCopy, faExternalLinkAlt, faHandPointRight);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VTooltip);
Vue.use(VModal, { dialog: true })
Vue.use(Input);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Button);
Vue.use(Row);
Vue.use(Col);


Vue.config.productionTip = false

var image1 = new Image(),
  image2 = new Image();

image1.src = `pics/bg-red.jpg`;
image2.src = `pics/bg-blue.jpg`;

getOrCreateGame().then(g => {
  store.game = g;
  new Vue({
    render: h => h(App),
  }).$mount('#app')
});